import { render, staticRenderFns } from "./InputErrors.vue?vue&type=template&id=06670394&scoped=true&"
import script from "./InputErrors.vue?vue&type=script&lang=js&"
export * from "./InputErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06670394",
  null
  
)

export default component.exports